import { cellNotFilter, formatDateWithTimeCell, gridSize0, TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { useGetSolicitudesIngreso } from "@/shared/actions/erp"
import { EstadoComponente, GeneralTable,} from "@/shared/components/ui"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { EstadosSolicitudIngresoEnum, IDataProducto, SolicitudesIngreso } from "@/shared/interfaces"
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, Grid } from "@mui/material"
import { MRT_ColumnDef, MRT_RowData } from "material-react-table"
import { useMemo, useState } from "react"

const RevisionSolicitudIngresoFinalizado = () => {
  //* store
  const handleCragarListaProductos = useSinSeriesProducto(s => s.handleCargarListaProductos)
  const listaProducto = useSinSeriesProducto(s => s.listaProducto)
  const paginatedData = useSinSeriesProducto(s => s.paginatedProductoData)
  const paginationTable = useSinSeriesProducto(s => s.pagination)
  const setPaginationTable = useSinSeriesProducto(s => s.setPagination)
  const clearSelectedItems = useSinSeriesProducto(s => s.clearSelectedItems)

  //*
  const [isOpenModal, setIsOpenModal] = useState(false)
  //**hook */
  const {
    pagination,
    setPagination,
    //globalFilter
  } = useTableFilter()
  const { pageIndex, pageSize } = pagination
  const {
    columnFilters,
    setColumnFilters,
    filterObject

  } = useTableServerSideFiltering();

  const {
    data: dataSolicitudIngresoFinalizado,
    isLoading,
    isRefetching

  } = useGetSolicitudesIngreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.FINALIZADO,
    ...filterObject,
    filterByState: false
  })
  const onDetails = (e: MRT_RowData) => {
    handleCragarListaProductos(e.productos)
    setIsOpenModal(true)
  }
  //
  const Columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: 'detalle',
        header: "Producto",
        size: 20,
        Cell: ({ row }) => {
          return (
            <Button
            variant="text"
            color="primary"
            startIcon={<VisibilityIcon />}
            onClick={() => { onDetails(row.original) }}
            >
            {'Ver'}
            </Button>
          )
        }
      },
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia'
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_creacion',
        header: 'fecha de creación',
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
        ...cellNotFilter,
        accessorKey: 'bodega_data.nombre',
        header: 'bodega'
      },
      {
        ...cellNotFilter,
        accessorKey: 'ubicacion_data.nombre',
        header: 'ubicación'
      },
      {
        ...cellNotFilter,
        accessorKey: 'user.username',
        header: 'Usuario'
      },
      {
        ...cellNotFilter,
        accessorKey: 'observaciones.observacionSolicitante',
        header: "Observación Solicitante",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => {
          return (
            <ModalObservacionGeneral
              texto={
                row.original.observaciones?.observacionSolicitante || 'N/A'
              }
              title="Observación"
            />
          )
        }
      },
      {
        ...cellNotFilter,
        accessorKey: "observaciones.observacionRevision",
        header: "observación del Revisor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionRevision || 'N/A'
            }
            title="Observación del Revisor"
          />
        )
      },
      {
        ...cellNotFilter,
        accessorKey: 'estado_solicitud',
        header: 'estado',
        Cell: ({ row }) => {
          return (
            <EstadoComponente
              backgroundColor="green"
              texto={row.original.estado_solicitud || ''}
            />
          )
        }
      }
    ], []
  )
  const columnsPorductFinalizados = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'cantidad',
        header: 'Cant. Requerida'
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada'
      },
      {
        accessorKey: 'codigo',
        header: 'Código',
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo'
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria'
      },
    ], []
  )
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable
            columns={Columns}
            data={dataSolicitudIngresoFinalizado?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataSolicitudIngresoFinalizado?.data.count}
            //
            enableGlobalFilter={false}
            //
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //crud
            enableColumnActions={true}
            enableEditing={false}
            canDelete={false}
          />
        </Grid>
        <ScrollableDialogProps
          title="Detalle Producto"
          open={isOpenModal}
          onCloseIcon={() => { setIsOpenModal(false), clearSelectedItems() }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item {...gridSize0}>
                <SampleTablePagination
                  columns={columnsPorductFinalizados}
                  data={paginatedData}
                  rowCount={listaProducto.length}
                  pagination={paginationTable}
                  setPagination={setPaginationTable}
                  rowNumber={true}
                />
              </Grid>

            </Grid>
          }
        />

      </Grid>
    </>
  )

}
export default RevisionSolicitudIngresoFinalizado